<template>
<div>
    <v-dialog
        v-model="display"
        persistent
        width="500">
        <v-card flat>
            <v-card-title>{{ title }}</v-card-title>
            <div class="text-center" v-if="loading.data">
                <v-progress-circular indeterminate>
                </v-progress-circular>
            </div>
            <v-card-text v-else>
                <v-form v-model="valid" ref="form">
                    <v-text-field
                        disabled
                        v-model="form.account_name"
                        :label="$t('account_name')"
                        :rules="rules.required">
                    </v-text-field>
                    <!-- TODO: will be implemented in near future -->
                    <!-- <v-select
                        v-model="form.site_id"
                        :label="$t('account_to_site')"
                        :items="sites"
                        item-value="id"
                        item-text="name"
                        :menu-props="{
                                down: true,
                                offsetY: true
                            }"
                        clearable
                        @click:clear="form.site_id = null">
                    </v-select> -->
                    <!-- TODO: remove hardcoded account group. :P 14 = Trade Receivble. We had to to this wallahi :( -->
                    <v-select
                        :label="$t('group')"
                        v-model="form.group_id"
                        :items="receivableGroups"
                        readonly
                        item-text="displayName"
                        item-value="id"
                        :loading="loading.accountGroup"
                        hide-no-data
                        :rules="rules.required">
                    </v-select>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-btn @click="submit" :disabled="!valid" text>{{ $t('save_btn') }}</v-btn>
                <v-btn @click="close" text>{{ $t('close_btn') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <retry-dialog ref="retryDialog" @submit="onRetryDialogSubmit">
    </retry-dialog>
</div>
</template>

<script>
import {
    mapActions,
    mapState
} from 'vuex';

import { getGroupAccountByType } from '../../services/ledger/account';
import { getDpk } from '../../services/sales';
import { createCustomerReceivableAccount } from '../../services/sales/customer';

import RetryDialog from '../common/RetryDialog.vue';

export default {
    components: {
        RetryDialog
    },
    name: "CustomerAssignDialog",
    props: {
        id: Number,
        customerName: String,
        customerId: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            display: true,
            valid: false,
            form: {
                account_name: null,
                site_id: null,
                group_id: null,
                group: null
            },
            loading: {
                accountGroup: false,
                data: false
            },
            search: null,
            receivableGroups: [],
            rules: {
                required: [
                    v => !!v || this.$t("rules_required")
                ],
            }
        }
    },
    computed: {
        ...mapState("sales/site", ["sites"]),
        ...mapState("accounting/accountGroup", ["groups"]),
        editMode() {
            return !this.notEditMode;
        },
        notEditMode() {
            return !this.id;
        },
        title() {
            if (this.notEditMode) return this.$t('new_customer_account');
            else return this.$t('edit_customer_account');
        }
    },
    methods: {
        ...mapActions("sales/site", ["fetchSites"]),
        ...mapActions('sales/customerAccount', ["fetchCustomerAccount", "storeCustomerAccount", "updateCustomerAccount"]),
        ...mapActions('common/snackBar', ["setSnackBars"]),
        ...mapActions('accounting/accountGroup', ["setGroups"]),
        async fetchAccountGroups() {
            if(this.groups.length > 0) {
                this.receivableGroups = this.groups;
                this.setDefaultGroupAccountValue();
                return;
            }
            // TODO: remove type_id and set this as a constant instead of ID
            this.loading.accountGroup = true;
            getGroupAccountByType({type_id: 5})
                .then(response => {
                    this.receivableGroups = response.data;
                    this.setDefaultGroupAccountValue();
                    this.setGroups(this.receivableGroups);
                })
                .finally(() => {
                    this.loading.accountGroup = false;
                });
        },
        // TODO: remove this. this is hardcoded and temporary. :P
        setDefaultGroupAccountValue() {
            this.form.group_id = 14; // Trade Recevables
        },
        async createdDataFetch() {
            try {
                this.loading.data = true;
                if (this.editMode) {
                    let result = await this.fetchCustomerAccount(this.id);
                    this.form = result.data;
                } else {
                    let dpkResponse = await getDpk();
                    this.dpk = dpkResponse.data.key;
                    // await this.fetchSites({
                    //     customer_id: this.customerId
                    // });
                    this.form.account_name = this.customerName;
                }
                this.loading.data = false;
            } catch (error) {
                let message = error.response ? error.response.data.message : error;
                this.$refs.retryDialog.open({
                    target: "createdDataFetch",
                    message
                });
            }
        },
        onRetryDialogSubmit(params) {
            if (params.target == "createdDataFetch") {
                if (params.retry) this.createdDataFetch();
            }
        },
        submit() {
            this.loading.submit = true;
            // if(this.notEditMode) {
            // service(`sales/customers/${this.customerId}/accounts`, 'post', this.form)
            createCustomerReceivableAccount({customerId: this.customerId, form: this.form, dpk: this.dpk})
                .then(() => {
                    this.close();
                    this.$emit('submit');
                    this.setSnackBars({
                        color: "success",
                        message: this.$t("record_save_success")
                    });
                })
                .catch(error => {
                    this.loading.submit = false;
                    let message = error.response ? error.response.data.message : error;
                    this.setSnackBars({
                        color: "error",
                        message
                    });
                })
            // } else {
            //     this.updateCustomerAccount(this.form)
            //         .then(() => {
            //             this.close();
            //             this.$emit('submit');
            //             this.setSnackBars({color: "success", message: this.$t("record_update_success")});
            //         })
            //         .catch((error) => {
            //             this.loading.submit = false;
            //             let message = error.response ? error.response.data.message : error;
            //             this.setSnackBars({color: "error", message});
            //         })
            // }
        },
        close() {
            this.$emit('close');
        }
    },
    created() {
        this.createdDataFetch();
        this.fetchAccountGroups();
    }
}
</script>

<style>

</style>
